import type { UserOut } from '@/api/generated/schemas';

export const getUserDisplayName = (record: UserOut) =>
  record.first_name || record.last_name
    ? `${record.first_name ?? ''} ${record.last_name ?? ''}`.trim()
    : record.username;

export const USER_SHOW_TABS = [
  'general',
  'consents',
  'oauth_accounts',
  'oauth_tokens',
  'fcm_tokens',
  'licences',
  'entitlements',
] as const;
export type UserShowTab = (typeof USER_SHOW_TABS)[number];
export const USER_DEFAULT_TAB: UserShowTab = 'general';
